import { ApiTypes } from '@mode/shared/contract-common';
import { MembershipResource } from './membership.resource';

export interface PaginationBlock {
  page: number;
  total_pages: number;
  total_count: number;
}

export interface MemberSearchResponse extends ApiTypes.ModeResource {
  pagination: PaginationBlock;
  filter: 'current' | 'banned' | 'admin' | 'pending';
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MemberSearchHelpers {
  export function memberships(resource: MemberSearchResponse): MembershipResource[] {
    return resource.embedded('memberships');
  }
}
